import React from "react";
import { Route, Switch } from "react-router-dom";
import { Path } from "paths";
import { PreAuthTransactionListModule } from "modules";
import { useMount } from "hooks";
import { setPageTitle } from "services";

const PreAuthTransactionPage = () => {
  useMount(() => {
    setPageTitle("pre-auth-transaction");
  });
  return (
    <Switch>
      <Route exact path={Path.PRE_AUTH_TRANSACTION_LIST} component={PreAuthTransactionListModule} />
    </Switch>
  );
};

export default PreAuthTransactionPage;
